import { useLocation } from 'react-router';

import { useAuthSession } from 'hooks/useAuthSession';
import { resolveProfileType } from 'utils/resolveProfileType';

import type { ChatViewerRole } from '../api/routes';

/** Chat viewer role: route prefix wins over role cookie (dual-role accounts). */
export const useChatViewerRole = (): ChatViewerRole => {
  // Hooks must run unconditionally (Rules of Hooks) - call session before early returns.
  const { pathname } = useLocation();
  const { data: session } = useAuthSession();

  if (pathname.startsWith('/teacher')) {
    return 'tutor';
  }
  if (pathname.startsWith('/profile')) {
    return 'student';
  }

  const profileType = resolveProfileType({
    sessionRoles: session?.roles ?? [],
    pathname,
  });
  return profileType === 'tutor' ? 'tutor' : 'student';
};
